module.exports = __webpack_public_path__ + "media/images/kinolift-white-9fef37f95ec1b1c387c4fd611a9feb2a.png";